export enum SideNavVariant {
  TEMPORARY = "temporary",
  PERMANENT = "permanent",
  PERSISTENT = "persistent",
}
